import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface TokenResponse {
  accessToken: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class TokenProviderService {
  constructor(private http: HttpClient) {}

  async getAccessToken(): Promise<string> {
    try {
      const response = await this.http
        .get<TokenResponse>('/api/google/route-optimization-token')
        .toPromise();

      if (!response.accessToken) {
        throw new Error('No accessToken in response');
      }

      return response.accessToken;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Unknown error';
      throw new Error(`Failed to retrieve token from backend: ${message}`);
    }
  }
}
